import axios from 'axios'
import { getToken } from '@/utils/auth'
import { loadAuthorizedFileBlob, resolveFileDownloadUrl } from '@/utils/upload'

export function isFinanceFileId(value) {
  return /^[a-fA-F0-9]{32}$/.test(String(value || '').trim())
}

export function attachmentFileName(disposition, fallback = '附件') {
  const value = String(disposition || '')
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(value)
  const plain = /filename="([^"]+)"|filename=([^;]+)/i.exec(value)
  let name = plain ? (plain[1] || plain[2]).trim() : fallback
  if (encoded) {
    try { name = decodeURIComponent(encoded[1]) } catch (_) { /* Keep the safe fallback. */ }
  }
  return name.replace(/[\\/\x00-\x1f\x7f]/g, '_') || fallback
}

export async function loadFinanceFile(fileRef, { refundId = '' } = {}) {
  const value = String(fileRef || '').trim()
  if (!value) throw new Error('文件标识不能为空')
  // Historical references keep their old URL/path handling, without forwarding tokens to external URLs.
  if (!isFinanceFileId(value)) {
    return { blob: await loadAuthorizedFileBlob(value), fileName: attachmentFileName('', value.split('/').pop().split('?')[0] || '附件') }
  }
  const route = refundId ? `/refunds/${encodeURIComponent(refundId)}/files` : '/files'
  const response = await axios({
    url: `${import.meta.env.VITE_APP_BASE_API}/caiwu-api/finance${route}/${encodeURIComponent(value)}`,
    method: 'get',
    responseType: 'blob',
    headers: { Authorization: `Bearer ${getToken() || ''}` }
  })
  const blob = response.data
  if (!(blob instanceof Blob) || !blob.size) throw new Error('文件不存在或无权访问')
  if (/application\/json/i.test(blob.type)) {
    throw new Error('文件不存在或无权访问')
  }
  return { blob, fileName: attachmentFileName(response.headers['content-disposition']) }
}

export function saveFileBlob(blob, fileName) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export async function downloadFinanceFile(fileRef, { refundId = '' } = {}) {
  const value = String(fileRef || '').trim()
  if (!isFinanceFileId(value)) {
    if (value) window.open(resolveFileDownloadUrl(value), '_blank', 'noopener,noreferrer')
    return
  }
  const { blob, fileName } = await loadFinanceFile(value, { refundId })
  saveFileBlob(blob, fileName)
}
